<script>
export default {
    name: 'GlobalUtilitiesMixin',
    data() {
        return {
            breakpoint: {
                isSmall: window.innerWidth <= 480,
                isMedium: window.innerWidth > 480 && window.innerWidth < 770,
                isLarge: window.innerWidth >= 770
            }
        }
    },
    methods: {
        resizeBreakpoints() {
            this.breakpoint.isSmall = window.innerWidth <= 480;
            this.breakpoint.isMedium = window.innerWidth > 480 && window.innerWidth < 770;
            this.breakpoint.isLarge = window.innerWidth >= 770;
        }
    }
}
</script>